import * as stylex from '@stylexjs/stylex';
import { styles } from './spinner.styles';
import { useT } from '@xantory/i18n';
type SpinnerSize = 'sm' | 'md' | 'lg';
type SpinnerTone = 'default' | 'inherit';
interface SpinnerProps {
  size?: SpinnerSize;
  /** 'inherit' draws the ring in currentColor — for spinners inside colored
   *  controls (e.g. a loading Button) where the token ring wouldn't read. */
  tone?: SpinnerTone;
  /** A SECTION's loader: centred in a full-width area with room of its own.
   *  A bare spinner standing in for a section sat at that section's top-left
   *  corner as a small ring and then the content "jumped" in (user,
   *  2026-09-30). Inline uses (a button, a heading) leave this off. */
  block?: boolean;
}
export function Spinner({
  size = 'md',
  tone = 'default',
  block = false
}: SpinnerProps) {
  const t = useT('ui');
  const ring = <span role="status" aria-label={t('loading')} {...stylex.props(styles.base, styles[size], tone === 'inherit' && styles.inherit)} />;
  return block ? <div {...stylex.props(styles.block)}>{ring}</div> : ring;
}